import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#rate-table-auto-refinance-app', App);
